(function (window, $) {
  let pathNameForm = window.location.pathname;
 
  window.addEventListener("pageshow", function (event) {
    let messageTopStep = document.querySelector(".message-top-1--section");
    let dataUpdateForm = document.querySelector(".data-update-form")
    let perfEntries = performance.getEntriesByType("navigation");

    if(messageTopStep != null){
      let classesMessage = messageTopStep.className.split(" ");
      if(classesMessage[1] !== "step-1"){
        dataUpdateForm.classList.remove("loading");
        if (perfEntries[0].type !== "prerender" && pathNameForm == "/" ) {
          dataUpdateForm.classList.add("loading")
          window.location.reload();
          
          }
        }

      }

      if(perfEntries[0].type == "navigate" || perfEntries[0].type == "back_forward" && pathNameForm == "/finalizado"){

        let btnHome = document.querySelector(".views-field-field-link-grupo-exito a");

        if (btnHome != null) {
          btnHome.addEventListener("click",(e)=>{
            e.preventDefault();
            window.location.reload();
  
          })
        }
        
      }
    
  });
  
})(window, jQuery);
